

import React from 'react'

import ClipLoader from "react-spinners/ClipLoader"

import styleClasses from './Loading.module.css';

export default function Loading({style = {}}) {
    return (
        <div className={styleClasses["lc-loading"]} style={style}>
            <ClipLoader size={24} color="var(--gray-8)" />
        </div>
    )
}
